import { ClientSummary as ClientSummaryResponse } from '@wtax/data-angular';
import { ClientSummary } from '../interfaces/client-summary.interface';

export const mapClientSummaryResponse = (response: ClientSummaryResponse): ClientSummary => ({
  id: response.id,
  name: response.name,
});
